import React from 'react';
import { Button } from '../../../../../components';
import { WrapIElement } from './styles';

const Interactive = (props: any) => {
  const {
    children,
    testid,
    bkgColorEnabled,
    bkgColorHover,
    bkgColorFocus,
    bkgColorPressed,
    onClick,
    onKeyDown,
    height,
    width,
    maxWith,
    minWidth,
    disabled,
    ref,
    cursor,
    hasInteraction,
    tabIndexButton
  } = props;

  return (
    <WrapIElement
      bkgColorEnabled={bkgColorEnabled}
      bkgColorHover={bkgColorHover}
      bkgColorFocus={bkgColorFocus}
      bkgColorPressed={bkgColorPressed}
      data-testid={testid}
      width={width}
      height={height}
      maxWidth={maxWith}
      minWidth={minWidth}
    >
      <>
        <Button
          ref={ref}
          as={hasInteraction ? 'button' : 'div'}
          role="button"
          type="button"
          className={`IElement ${hasInteraction ? 'interaction' : ''}`}
          {...props}
          onClick={hasInteraction ? onClick : () => {}}
          onKeyDown={onKeyDown}
          delayClick={100}
          disabled={disabled}
          cursor={hasInteraction ? cursor : 'default'}
          tabIndexButton={tabIndexButton}
        >
          {children}
        </Button>
      </>
    </WrapIElement>
  );
};

Interactive.defaultProps = {
  hasInteraction: true
};

export default Interactive;
